import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import TableComponent from "../../components/widgets/table/index";
import CreateDirectQuotationModal from "../../components/widgets/modals/DirectQuotation";
import { api_srv } from "services";
import { useQuery } from "react-query";


function DirectQuotation() {
  const history = useHistory();
  const [quotations, setQuotations] = useState([
    // Simulated quotations for UI demonstration
    {
      id: 1,
      internalRef: "DQ-001",
      insurance: "MOTOR",
      coverType: "COMPREHENSIVE",
      product: "PROD1",
      coverStartDate: "2025-10-01",
      coverPeriod: "12_MONTHS",
      firstName: "John",
      lastName: "Doe",
      email: "john.doe@example.com",
      description: "Comprehensive motor insurance for a sedan",
      kraPin: "A123456789B",
      dmiVicUpload: "/uploads/dmi_vic_001.pdf",
      kycType: "INDIVIDUAL",
      value: 500000,
      model: "MODEL1",
      chassis: "CH123456789",
      regNo: "KXX123Y",
      year: 2020,
      make: "Toyota",
      color: "Blue",
      status: "PENDING",
      createdAt: new Date().toISOString(),
      benefits: [
        { id: "1", name: "Hospitalization Benefit", description: "Covers hospital stays up to 30 days", type: "HEALTH", limit: 50000, adjustBenefit: true },
        { id: "2", name: "Surgical Benefit", description: "Covers surgical procedures", type: "HEALTH", limit: 25000, adjustBenefit: false },
        { id: "3", name: "Accident Cover", description: "Personal accident coverage", type: "MOTOR", limit: 100000, adjustBenefit: true }
      ],
      premium_total: 25000,
      currency: "KSH"
    },
    {
      id: 2,
      internalRef: "DQ-002",
      insurance: "HEALTH",
      coverType: "BASIC",
      product: "PROD2",
      coverStartDate: "2025-11-01",
      coverPeriod: "6_MONTHS",
      firstName: "Jane",
      lastName: "Smith",
      email: "jane.smith@example.com",
      description: "Basic health insurance coverage",
      kraPin: "B987654321C",
      dmiVicUpload: "/uploads/dmi_vic_002.pdf",
      kycType: "INDIVIDUAL",
      value: 100000,
      model: "MODEL2",
      chassis: "CH987654321",
      regNo: "KYY456Z",
      year: 2018,
      make: "Honda",
      color: "Red",
      status: "APPROVED",
      createdAt: new Date().toISOString(),
      benefits: [],
      premium_total: 15000,
      currency: "KSH"
    },
    {
      id: 3,
      internalRef: "DQ-003",
      insurance: "PROPERTY",
      coverType: "COMPREHENSIVE",
      product: "PROD1",
      coverStartDate: "2025-10-15",
      coverPeriod: "12_MONTHS",
      firstName: "Mike",
      lastName: "Johnson",
      email: "mike.johnson@example.com",
      description: "Comprehensive property insurance for commercial building",
      kraPin: "C123456789D",
      dmiVicUpload: "/uploads/dmi_vic_003.pdf",
      kycType: "BUSINESS",
      value: 2000000,
      model: "N/A",
      chassis: "N/A",
      regNo: "N/A",
      year: 2023,
      make: "N/A",
      color: "N/A",
      status: "DRAFT",
      createdAt: new Date().toISOString(),
      benefits: [],
      premium_total: 50000,
      currency: "KSH"
    }
  ]);
  const [showModal, setShowModal] = useState(false);

    const get_client_quotations = async () => {
    let resp = await (await api_srv).fetchClientQuotations();
    console.log("resp cq===", resp)
    return resp?.data;
    };


        //quotation sample
        //  {
        //         "_id": "68ae0a5a037869ce6fbc6fcd",
        //         "systemQuotationRef": "83d3ac8f-5a46-46c2-983c-f0d4733d82be",
        //         "bussinessType": "DIRECT",
        //         "productSystemRef": "87acacfe-b8ef-4442-8f62-70278d3ac222",
        //         "underwriterSystemRef": "25e1b7d1-a6e3-4c31-bcc7-4f2c8a764a17",
        //         "insuranceClassRef": "07",
        //         "intermediarySystemRef": "277",
        //         "entityRef": "277",
        //         "clientDetails": {
        //             "email": "test@ymail.com",
        //             "names": {
        //                 "fname": "testf",
        //                 "lname": "testl"
        //             },
        //             "kyc": {}
        //         },
        //         "risks": [
        //             {
        //                 "riskType": "ASSET",
        //                 "value": 1000000,
        //                 "riskRef": "KBN556T",
        //                 "details": {}
        //             }
        //         ],
        //         "quotationCoverDetails": {
        //             "coverPeriod": 10,
        //             "coverType": "ICT00103824"
        //         },
        //         "quotationAdditionalBenefits": [],
        //         "quotationPremium": {
        //             "basePremium": 3000000,
        //             "additionalPremium": 0,
        //             "totalCharges": 0,
        //             "totalPremium": 3000000
        //         },
        //         "quotationCurrency": "KES",
        //         "quotationExceptions": [],
        //         "quotationSettlement": {
        //             "underwriterAmount": 3000000,
        //             "intermediaryAmount": 0,
        //             "salesrepAmount": 0
        //         },
        //         "quotationChannel": "web",
        //         "quotationNotes": [],
        //         "quotationInternalRef": "",
        //         "quotationStatus": "active",
        //         "quotationPayment": {
        //             "paymentStatus": "pending",
        //             "paymentRef": "",
        //             "paymentType": "auto",
        //             "paymentChannel": "",
        //             "paymentBy": "",
        //             "paymentDate": "",
        //             "paidAmount": 0
        //         },
        //         "hasException": false,
        //         "createdAt": "2025-08-26T19:26:18.256Z",
        //         "updatedAt": "2025-08-26T19:26:18.256Z",
        //         "id": "83d3ac8f-5a46-46c2-983c-f0d4733d82be"
        //     },

    const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['clientQuotations'], // Unique key for the query
    queryFn: get_client_quotations, // The async function to fetch data
    });

    // Handle loading state
    if (isLoading) {
      return <div>Loading...</div>;
    }

    // Handle error state
    if (isError) {
      return <div>Error: {error.message}</div>;
    }

    let quotes = data[0]?.items


  // Table configuration
  const tableFields = [
    { name: "Internal Reference" },
    {name: "premium"},
    { name: "Status" },
    { name: "First Name" },
     { name: "Last Name" },
    // { name: "Product" },
    { name: "Cover Start Date" },
    { name: "Cover Period" },
    { name: "Payment Status" },
    { name: "Action" },
  ];

  const tableRowData = [
    { type: "text", field: "systemQuotationRef" },
    { type: "text", field: "quotationPremium.totalPremium"},
    { type: "text", field: "quotationStatus" },
    { type: "text", field: "clientDetails.names.firstName" },
    { type: "text", field: "clientDetails.names.lastName" },
    // { type: "text", field: "product" },
    { type: "date", field: "quotationCoverDetails.startDate" },
    { type: "text", field: "quotationCoverDetails.coverPeriod" },
    { type: "text", field: "quotationPayment.paymentStatus" },
    {
      type: "action",
      field: "id",
      actions: [
        {
          method: (id) => {
            console.log(`Navigating to view quotation ${id}`);
            history.push(`/dashboard/direct-quotation/${id}`);
          },
          field: "id",
          title: "View"
        }
      ]
    },
  ];

  // Handle modal toggle
  const handleShowModal = () => setShowModal(true);
  const handleHideModal = () => setShowModal(false);

  return (
    
      <div className="card p-4 " style={
        { borderRadius: "12PX", background: "#ffffff",   padding:"2rem"}
      }>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0">Quotations</h4>
          <Button
            variant="primary"
            size="lg"
            className="btn btn-primary btn-lg d-flex align-items-center"
            onClick={handleShowModal}
          >
            New Quotation
          </Button>
        </div>
        <TableComponent
          title=""
          table_fields={tableFields}
          table_data={quotes}
          row_data={tableRowData}
          pageSize={10}
        />
        <CreateDirectQuotationModal
          show={showModal}
          onHide={handleHideModal}
          fetchQuotations={refetch}
        />
      </div>
  );
}

export default DirectQuotation;